


















import Vue from "vue";
import { Component } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import MethodicalMaterialListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/MethodicalMaterialModels/MethodicalMaterialListResponse";
import { Route, RawLocation } from "vue-router";
import MethodicalMaterialTagListItem from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/MethodicalMaterialModels/MethodicalMaterialTagListItem";
import MethodicalMaterialDetail from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/MethodicalMaterialModels/MethodicalMaterialDetail";
import MethodicalMaterialListItem from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/MethodicalMaterialModels/MethodicalMaterialListItem";
@Component
export default class PageMethodicalMaterialDetailComponent extends Vue {
  material: MethodicalMaterialListItem = null;
  text: String = null;
  materials: WsResponseModel<MethodicalMaterialListResponse> = null;
  mounted() {
    this.getDetail();
  }
  getDetail() {
    this.$api.MethodicalMaterialsService.GetDetailEvent.once(
      this.onGetDetail.bind(this)
    );
    this.$api.MethodicalMaterialsService.GetDetail(Number(this.$route.params.id));
  }
  onGetDetail(response: WsResponseModel<MethodicalMaterialDetail>) {
    if(!response.IsSuccess){
      this.material = null;
      this.text = 'Материал не найден, или произошла ошибка.'
      return;
    }
    this.$meta.setTitle(response.Value.Name+''||'Методическая копилка');
    this.text = response.Value.Text;
    this.material = {
      Id: response.Value.Id,
      Date:response.Value.Date,
      Teacher:response.Value.Teacher,
      Tags:response.Value.Tags,
      Name:response.Value.Name
    };
  }
}
